import React, { lazily } from 'react-lazily';

const { CSSTransition } = lazily(() => import('react-transition-group'));

export default function LazyCSSTransition({ ...props }) {
  return <CSSTransition {...props} />;
}
